import { render, staticRenderFns } from "./FlatRoof.vue?vue&type=template&id=08af5dbb"
import script from "./FlatRoof.vue?vue&type=script&lang=js"
export * from "./FlatRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports